// Address-based tax lookup contract.
// Phase 1 ships only the stub implementation; TaxJar / Avalara will plug in
// later as alternate TaxLookupFn implementations behind the same interface.

export interface TaxLookupAddress {
  streetAddress: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
}

export interface TaxLookupResult {
  combinedRate: number;
  stateRate: number;
  localRate: number;
  sourceLabel: string;        // 'stub' | 'taxjar' | 'avalara'
  rawPayload: unknown;        // preserved verbatim into shop_tax_snapshots.payload
  lookedUpAt: string;         // ISO timestamp
}

export type TaxLookupFn = (addr: TaxLookupAddress) => Promise<TaxLookupResult>;

/** Returns true when every required address field is non-empty. */
export function isCompleteAddress(addr: Partial<TaxLookupAddress>): addr is TaxLookupAddress {
  return Boolean(
    addr.streetAddress?.trim() &&
    addr.city?.trim() &&
    addr.state?.trim() &&
    addr.postalCode?.trim() &&
    addr.country?.trim()
  );
}
